'use client';

import { TextArea, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface BrandMessageInputProps {
  /** 섹션 타이틀 (default = "브랜드에 전달할 메시지") */
  title?: string;
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  /** 최대 글자수 (default = 200) */
  maxLength?: number;
  /** true 면 read-only (r-02 이후 등 frozen 표시) */
  disabled?: boolean;
  /**
   * true 면 상위 섹션(CampaignInfo.Container)의 아이템으로 삽입되는 모드 — 자체 px-16 만 제거.
   * (가로 여백은 상위 Container px-16 이 담당. 타이틀 pt-12 는 유지 → 상위 그룹 gap-12 와 합쳐 24px.)
   */
  embedded?: boolean;
  className?: string;
}

export const BrandMessageInput = ({
  title = '브랜드에 전달할 메시지',
  value,
  onChange,
  placeholder,
  maxLength = 200,
  disabled = false,
  embedded = false,
  className,
}: BrandMessageInputProps) => (
  <section className={twMerge('px-[16px]!', embedded && 'px-0!', className)}>
    {/* 타이틀 14px medium. (SID-4141) pt-12 는 embedded 에서도 유지 — 상위 그룹 gap-12 와 합쳐 24px. */}
    <div className="pt-[12px]! pb-[11px]!">
      <Typography variant="body14pxMed" colorScheme="black">
        {title}
      </Typography>
    </div>
    {disabled ? (
      <div className="rounded-[4px] bg-gray-100 px-[12px]! py-[10px]!">
        <Typography variant="body13pxReg" colorScheme={value ? 'black' : 'gray-600'}>
          {value || placeholder || ''}
        </Typography>
      </div>
    ) : (
      <TextArea
        value={value}
        onChange={(event) => onChange(event.target.value.slice(0, maxLength))}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={4}
        className="w-full resize-none!"
      />
    )}
    {!disabled && (
      <div className="flex justify-end mt-[4px]!">
        <Typography variant="body13pxReg" colorScheme="gray-600">
          {value.length} / {maxLength}
        </Typography>
      </div>
    )}
  </section>
);
